import { IDataSource } from '../data-sources.interface';

export interface IDataSourceAddEditDialogData {
  dialogTitle: string;
  submitButtonText: string;
  editData?: Omit<IDataSource, 'authentication'>;
}

export enum EDataSourceAuthenticationStrategy {
  none = 'none',
  basic = 'basic',
}
